import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';

import { D4ActiveTaskListWidgetConfiguration } from '../../../models/d4-active-tasks-list-widget.model';
import {
  WidgetConfigurationComponent,
  WidgetConfigurationType,
} from '../../../models/widget-configuration.model';

@Component({
  selector: 'carehub-d4-active-tasks-list-configuration',
  standalone: true,
  imports: [ButtonModule, InputNumberModule, ReactiveFormsModule],
  templateUrl: './d4-active-tasks-list-widget-configuration.component.html',
  styleUrl: './d4-active-tasks-list-widget-configuration.component.scss',
})
export class D4ActiveTasksListWidgetConfigurationComponent
  implements WidgetConfigurationComponent, OnInit {
  @Input() initialConfiguration: D4ActiveTaskListWidgetConfiguration | undefined;

  configForm: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.configForm = this.formBuilder.group({
      reloadDelay: [5, [Validators.required, Validators.min(1)]],
    });
  }

  ngOnInit(): void {
    if (this.initialConfiguration) {
      this.configForm.patchValue(this.initialConfiguration);
    }
  }

  isValid(): boolean {
    return this.configForm.valid;
  }

  getConfiguration(): WidgetConfigurationType {
    return this.configForm.value as D4ActiveTaskListWidgetConfiguration;
  }
}
